import { useMemo } from 'react'
import NextLink from 'next/link'

import { Text } from '@wartek-id/text-v1'
import { Button } from '@wartek-id/button-v1'

import { PageGuardPamongPelaksanaanStatus } from 'app/KinerjaPamongPage/components/pelaksanaan/PageGuardPamongPelaksanaanStatus'
import { Header } from 'app/KinerjaShared/components/Header'
import usePeriodContext from 'app/KinerjaShared/hooks/usePeriodContext'
import {
  SectionCard,
  SectionCardHeader,
  SectionCardBody,
  SectionCardFooter,
} from 'app/KinerjaShared/components/SectionCard'
import { HasilObservasiPraktikKinerjaPegawaiTable } from 'app/KinerjaShared/components/HasilObservasiPraktikKinerjaPegawaiTable'
import { PENGELOLAAN_KINERJA_PAMONG_PEGAWAI_PATH } from 'app/KinerjaShared/constants/path'
import { useSafeBackNavigation } from 'app/KinerjaShared/hooks/useSafeBackNavigation'
import { PRAKTIK_KINERJA_STEPS } from 'app/KinerjaPamongPage/constants/praktik-kinerja-steps'

import type { MultiPeriodPayload } from 'types/kinerja'

type PreRencanaTindakLanjutProps = {
  periodParams?: MultiPeriodPayload
}

export function PreRencanaTindakLanjut({
  periodParams,
}: PreRencanaTindakLanjutProps) {
  const { periodNo, periodYear } = usePeriodContext()

  const { handleBack } = useSafeBackNavigation({
    fallbackRoute: `${PENGELOLAAN_KINERJA_PAMONG_PEGAWAI_PATH}/pelaksanaan/praktik-kinerja`,
  })

  // -----------------------------------------
  // Resolve period params
  // -----------------------------------------
  const resolvedPeriodParams = useMemo(() => {
    if (periodParams) return periodParams

    // Default with current period
    return {
      skpPeriod: periodNo,
      skpYear: periodYear,
    }
  }, [periodParams, periodNo, periodYear])

  return (
    <main className="pt-12 px-8 pb-8">
      <div className="mx-auto max-w-7xl">
        <PageGuardPamongPelaksanaanStatus periodParams={resolvedPeriodParams}>
          <div className="flex justify-between items-center">
            <Header
              title={PRAKTIK_KINERJA_STEPS['DOCUMENT_FOLLOW_UP'].title}
              className="mb-9"
              onBack={handleBack}
            />
          </div>
          <SectionCard>
            <SectionCardHeader variant="light-blue">
              <Text as="h2" color="inherit" variant="heading-lg">
                Hasil Observasi Praktik Kinerja
              </Text>
            </SectionCardHeader>
            <SectionCardBody className="px-9 py-6 space-y-12">
              <HasilObservasiPraktikKinerjaPegawaiTable
                periodParams={resolvedPeriodParams}
              />
            </SectionCardBody>
            <SectionCardFooter className="justify-end">
              <NextLink
                href={`${PENGELOLAAN_KINERJA_PAMONG_PEGAWAI_PATH}/pelaksanaan/praktik-kinerja/rencana-tindak-lanjut`}
                passHref
              >
                <Button as="a" type={undefined} color="blue" size="lg">
                  Ke Rencana Tindak Lanjut
                </Button>
              </NextLink>
            </SectionCardFooter>
          </SectionCard>
        </PageGuardPamongPelaksanaanStatus>
      </div>
    </main>
  )
}
